export default __webpack_public_path__ + "static/media/clipSupport.65f28ddd.png";